import $axios from "@/api";

const groupUrl = "user/rekening";

const state = () => ({
  datas: [],
});

const mutations = {
  ASSIGN_DATA(state, payload) {
    state.datas = payload;
  },
};

const actions = {
  async listUserRekening({ commit }, filter) {
    try {
      const response = await $axios.get(`${groupUrl}`, { params: filter });
      commit("ASSIGN_DATA", response.data.data);
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async storeUserRekening({ commit, state }, payload) {
    try {
      const response = await $axios.post(`${groupUrl}`, payload);
      const updatedDatas = [...state.datas];
      updatedDatas.push(response.data.data);
      commit("ASSIGN_DATA", updatedDatas);
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async updateUserRekening({ commit, state }, payload) {
    try {
      const response = await $axios.put(`${groupUrl}/${payload.id}`, payload);
      const updatedDatas = [...state.datas];
      const index = updatedDatas.findIndex((item) => item.id === payload.id);
      if (index !== -1) {
        updatedDatas[index] = response.data.data;
        commit("ASSIGN_DATA", updatedDatas);
      }
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteUserRekening({ commit, state }, id) {
    try {
      const response = await $axios.delete(`${groupUrl}/${id}`);
      const updatedDatas = state.datas.filter((item) => item.id !== id);
      commit("ASSIGN_DATA", updatedDatas);
      return response;
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
